/* eslint-disable */
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FaTachometerAlt,
  FaBoxOpen,
  FaList,
  FaShoppingCart,
  FaUsers,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import "./Sidebar.css";
import logo from "../src/images/logo.png";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const routes = [
    { name: "Dashboard", path: "/dashboard", icon: <FaTachometerAlt /> },
    { name: "Products", path: "/products", icon: <FaBoxOpen /> },
    { name: "Categories", path: "/categories", icon: <FaList /> },
    { name: "Orders", path: "/orders", icon: <FaShoppingCart /> },
    { name: "Customers", path: "/customers", icon: <FaUsers /> },
  ];

  const handleNavigate = (path) => {
    navigate(path);
    setOpen(false); // auto close on mobile
  };

  return (
    <>
      {/* MOBILE HEADER */}
      <div className="mobile-header">
        <button className="hamburger" onClick={() => setOpen(!open)}>
          {open ? <FaTimes /> : <FaBars />}
        </button>
        <img src={logo} alt="Logo" className="mobile-logo" />
      </div>

      {/* SIDEBAR */}
      <div className={`sidebar ${open ? "open" : ""}`}>
        <div className="sidebar-logo">
          <img src={logo} alt="Admin Logo" />
        </div>

        <div className="sidebar-links">
          {routes.map((route, index) => (
            <div
              key={index}
              className={`sidebar-link ${
                location.pathname === route.path ? "active" : ""
              }`}
              onClick={() => handleNavigate(route.path)}
            >
              <span className="sidebar-icon">{route.icon}</span>
              <span className="sidebar-text">{route.name}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}